
import React from 'react';

const Thanks = () => {
  return (
    <div className="font-medium text-lg">
      <p className='p-24 text-center'>Thank you for submitting your valuable feedback</p>

    </div>
  );
};

export default Thanks;